import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-20 text-center" data-testid="not-found-page">
      <div className="text-8xl font-bold text-secondary mb-4">404</div>
      <h1 className="text-2xl font-semibold mb-2">Pagina non trovata</h1>
      <p className="text-muted-foreground mb-8 max-w-md mx-auto">La pagina che stai cercando non esiste o potrebbe essere stata spostata.</p>
      <div className="flex items-center justify-center gap-3">
        <Link to="/" className="h-10 px-5 rounded-lg bg-[hsl(214,58%,41%)] text-white text-sm font-medium flex items-center gap-2 hover:bg-[hsl(214,58%,46%)] transition-colors"><Home className="w-4 h-4" /> Torna alla Home</Link>
        <Link to="/prodotti/toner" className="h-10 px-5 rounded-lg border text-sm font-medium flex items-center gap-2 hover:bg-secondary/60 transition-colors"><Search className="w-4 h-4" /> Cerca Prodotti</Link>
      </div>
    </div>
  );
}
